import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ArticleLinkListItem } from '@/components/modules/pages/article/List/ArticleLinkList/ArticleLinkListItem';
/**
 * 記事一覧ページの上部に表示するリンク用のList
 *
 * @param props
 * @constructor
 */
export const ArticleLinkList = (props) => {
    const { className = '', items, pathname } = props;
    return (_jsx("nav", Object.assign({ className: className }, { children: _jsx("ul", Object.assign({ className: clsx('grid grid-cols-2 lg:grid-cols-4 gap-[1px]', 'border border-solid border-gray-300', 'bg-gray-300', 'lg:rounded-md', 'overflow-hidden') }, { children: items.map((item) => (_jsx("li", { children: _jsx(ArticleLinkListItem, { count: item.count, icon: item.icon, isActive: item.to === pathname, text: item.text, to: item.to }) }, item.text))) })) })));
};
